<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="form" ref="dataForm" :inline="true" :rules="formRules">
          <el-form-item label="教育公司名称：" prop="educationName">
            <el-input v-model="form.educationName" placeholder="请输入教育公司名称" size="small" />
          </el-form-item>
          <el-form-item label="负责人：" prop="userId">
            <el-select v-model="form.userId" placeholder="请选择" clearable size="small">
              <el-option :label="item.realName + '(' + item.userPho +')'" :value="item.id" v-for="item in userOptions" :key="item.key"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="负责人：" prop="chargeName">
            <el-input v-model="form.chargeName" placeholder="请输入负责人" size="small" />
          </el-form-item>
          <el-form-item label="负责人手机号：" prop="pho">
            <el-input v-model="form.pho" placeholder="请输入负责人手机号" size="small" maxlength="11" />
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="handleSave" size="mini" v-hasPermi="['technical:edCompany:edit']">保存</el-button>
          </el-form-item>
        </el-form>
        <div class="money-box" v-if="info">
          <span>账户余额：{{info.commissionMoney || 0}}元</span>
          <!-- <span>已提现金额：{{info.withdrawalAmount || 0}}元</span>
          <el-button type="primary" @click="handleWithdraw" size="mini" v-hasPermi="['technical:edCompany:withd']">提现</el-button> -->
        </div>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="filter-container" style="padding: 0;">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="用户手机号：" prop="name">
            <el-input v-model="query.pho" placeholder="请输入用户手机号" size="small" />
          </el-form-item>
          <template v-if="activeName === '1'">
            <el-form-item label="加盟类型：">
              <el-select v-model="query.jmLevel" placeholder="请选择" clearable size="small">
                <el-option label="体验班" :value="7"></el-option>
                <el-option label="研修班" :value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="加盟方式：">
              <el-select v-model="query.source" placeholder="请选择" clearable size="small">
                <el-option label="本人申请" :value="1"></el-option>
                <el-option label="业务员申请" :value="2"></el-option>
                <el-option label="后台提交" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="学费" name="1"></el-tab-pane>
          <el-tab-pane label="课程" name="7"></el-tab-pane>
          <el-tab-pane label="会议" name="8"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
          <el-button type="primary" size="mini" @click="handleDownload" plain v-hasPermi="['technical:edCompany:export']">导出</el-button>
        </div>
      </div>
      <el-table v-show="activeName === '1'" v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="用户信息" prop="name" align="center" fixed width="200" key="1">
          <template slot-scope="{row}">
            {{row.name}}({{row.levelName}})<br />
            {{row.pho}}
          </template>
        </el-table-column>
        <el-table-column label="加盟类型" prop="name" align="center" fixed key="2">
          <template slot-scope="{row}">
            {{row.jmType==7?'体验班':'研修班'}}
          </template>
        </el-table-column>
        <el-table-column label="加盟方式" prop="name" align="center" fixed key="3">
          <template slot-scope="{row}">
            {{row.source}}
          </template>
        </el-table-column>
        <el-table-column label="申请人信息" prop="name" align="center" key="4">
          <template slot-scope="{row}">
            {{row.czName}}{{row.czLevel? '(' + row.czLevel + ')':''}}<br />
            {{row.czPho}}
          </template>
        </el-table-column>
        <el-table-column label="加盟金额" prop="fee" align="center" key="5">
        </el-table-column>
        <el-table-column label="教育公司获得金额" prop="money" align="center" key="6">
        </el-table-column>
        <el-table-column label="绑定业务员" prop="name" align="center" key="7">
          <template slot-scope="{row}">
            {{row.ywcustomerPO && row.ywcustomerPO.name}}({{row.ywlevel}})<br />
            {{row.ywcustomerPO &&row.ywcustomerPO.pho}}
          </template>
        </el-table-column>
        <el-table-column label="绑定技术老师" prop="name" align="center" key="8">
          <template slot-scope="{row}">
            {{row.technician && row.technician.realName}}({{row.technician && row.technician.levelName}})<br />
            {{row.technician && row.technician.mobile}}
          </template>
        </el-table-column>
        <el-table-column label="加盟时间" prop="joinTime" align="center" fixed width="170" key="9">
        </el-table-column>
      </el-table>
      <el-table v-show="activeName != '1'" v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="用户信息" prop="name" align="center" fixed width="200" key="10">
          <template slot-scope="{row}">
            {{row.customerName}}({{row.customerLevel}})<br />
            {{row.customerPho}}
          </template>
        </el-table-column>
        <el-table-column label="购买内容" prop="courserName" align="center" fixed key="11" />
        <el-table-column label="支付金额" prop="payMoney" align="center" key="12" />
        <el-table-column label="教育公司获得金额" prop="commissionMoney" align="center" key="13" />
        <el-table-column label="绑定业务员" prop="name" align="center" key="14">
          <template slot-scope="{row}">

            {{row.ywcustomerPO && row.ywcustomerPO.name}}({{row.ywlevel}})<br />
            {{row.ywcustomerPO && row.ywcustomerPO.pho}}
          </template>
        </el-table-column>
        <el-table-column label="绑定技术老师" prop="name" align="center" key="15">
          <template slot-scope="{row}">
            {{row.technician && row.technician.realName}}({{row.technician && row.technician.levelName}})<br />
            {{row.technician && row.technician.mobile}}
          </template>
        </el-table-column>
        <el-table-column label="购买时间" prop="buyTime" align="center" fixed width="170" key="16" />
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <withdraw ref="withdraw" @created="doQueryList({})" />
  </div>
</template>

<script>
import userApi from '@/api/sys/user'
import withdraw from './withdraw'
import educationCompanyApi from '@/api/education'
import Pagination from '@/components/Pagination'
import { filterEmpty } from '@/utils'
export default {
  components: {
    Pagination,
    withdraw
  },
  data() {
    return {
      formRules: {
        pho: [{
          pattern: /^[0-9]*$/,
          message: '请输入正确的手机号'
        }],
      },
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      selectItems: [],
      activeName: '1',
      info: null,
      form: {
        // pho: null,
        // chargeName: null,
        userId: null,
        educationName: null
      },
      userOptions: []
    }
  },
  created() {
    this.getInfo()
    this.getUserList()
  },
  methods: {
    getUserList() {
      userApi.fetchList({ pageNo: 1, pageSize: 1000, isInternal: 1, jobStatus: 1 })
        .then(({ data }) => {
          this.userOptions = data.list
        })
    },
    handleDownload() {
      let code = this.activeName == '1' ? 'educationDownloadExcel' : 'educationCourserOrMeetingExport'
      this.$router.push(`/export/list?code=${code}&commissionSource=${this.activeName}`)
    },
    handleSave() {
      if (this.info) {
        educationCompanyApi.update({ ...this.form, id: this.info.id }).then((data) => {
          this.getInfo()
        })
      } else {
        educationCompanyApi.create(this.form).then((data) => {
          this.getInfo()
        })
      }
    },
    getInfo() {
      educationCompanyApi.fetchById().then(({ data }) => {
        this.info = data
        if (data) {
          Object.keys(this.form).forEach(key => {
            this.form[key] = data[key]
          });
        }
        this.doQueryList({ pageNo: 1 })
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({
        pageNo: 1
      })
      // console.log("activeName: ",this.activeName);
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 触发重置操作
     */
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10
      }
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.userId = this.info && this.info.userId;
      let params = { ...this.query }
      if (this.activeName != '1') params.commissionSource = +this.activeName
      this.listLoading = true
      let Ins = this.activeName === '1' ? educationCompanyApi.fetchList : educationCompanyApi.getEducationComList
      return Ins(filterEmpty(params)).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    /**
     * 提现
     */
    handleWithdraw() {
      this.$refs.withdraw.handleCreate()
    }
  }
}
</script>
<style lang="scss" scoped>
.money-box {
  & > span {
    font-size: 14px;
    margin-right: 50px;
  }
}
</style>
